// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_rAO","cls2":"ImpactHubModal-cls2_PcB ImpactHubModal-cls1_rAO"};